<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      :close-on-select="false"
      :searchable="true"
      :options="options"
      :loading="loading"
      :disabled="isDisabled"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: [
    'modelValue',
    'entity',
    'returnedField',
    'filterField',
    'filterValue',
    'isDisabled',
    'returnedPk',
    'customOptions'
  ],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    filterValue() {
      this.getOptions();
    },
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      this.$emit(
        'onChange',
        this.value,
        this.options.find((o) => o.value == this.value)
      );
    }
  },
  mounted() {
    this.getOptions();
    if (this.modelValue) {
      this.value = this.modelValue;
    }
  },
  methods: {
    getOptions() {
      if (this.customOptions) {
        this.options = this.customOptions;
        return;
      }
      this.loading = true;
      this.$api
        .get(`api/${this.entity}?${this.filterField}=${this.filterValue}`)
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            if (this.entity === 'action/all') {
              return {
                value: b.action_id,
                label: b.action_name + ' - ' + b.affiliate_token + ' - ' + b.campaign_name,
                data: { ...b }
              };
            }
            return { value: b[this.returnedPk || 'id'], label: b[this.returnedField || 'name'], data: { ...b } };
          });
          if (this.entity === 'document_type') {
            this.options.unshift({
              value: 'email',
              label: 'email',
              data: {}
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
